import * as PIXI from "pixi.js";


export const disabledfilter = new PIXI.ColorMatrixFilter()
disabledfilter.desaturate();


export const brightnessFilter = new PIXI.ColorMatrixFilter();
brightnessFilter.brightness(1.1, true);
brightnessFilter.resolution = 2; 